import XLSX from "xlsx-js-style";


function filterQuestionsByMinCavLevel(minCavLevel){
  return(
    (qList, cav) => {
    if(cav.score <= minCavLevel){
      qList.push(cav.question)
    }
    
    return(qList)
  })
}

function setFillColor(score){
  switch (score){
    case -3:
      return("FF0000") //red
    case -2:
      return("FFA500") //orange
    case -1:
      return("E7D850") //custom yellow (from caveatColor.js)
    case 2:
      return("32CD32") //limegreen
    default:
      return("FFFFFF") //white
  }

}

function buildOptionRowArr(opt, filteredQIds, includeCavText, includeGreen){
  
  var cavArr = filteredQIds.map(qid => {
    let cav = opt.caveats.find(c => qid===c.question) 
    //don't include greens if not selected
    return((cav && (cav.score !== 2 || includeGreen)) ? {v: includeCavText ? cav.title : "", t: "s", s:{fill: { fgColor: { rgb: setFillColor(cav.score) } }} } : {v:""}) 
  })
  return([opt.title, ...cavArr])
}

export function createCaveatMatrixXLS(selectedItems, options, questionLookup, section, fisheryTitle, minCavLevel, includeCavText, includeGreen){
  //find questions with caveats that meet min level for selectedItems
  //first row is those questions
  //loop through selected items and make array for name and color/text for any caveats in filtered question list

  //get options array for the selectedItems
  var selectedOptions = options.filter(o => (selectedItems.findIndex(element => element === o.id)) >= 0)
  
  //find questions that meet minCavLevel from selected options
  //for each option, filter caveats to min level, add question id to list
  let filteredQuestionIDs = [...new Set(selectedOptions.flatMap(o => o.caveats.reduce(filterQuestionsByMinCavLevel(minCavLevel), [])).filter(e => e !== undefined))] //filter to catch bad data from old cases

  var filteredQuestions = filteredQuestionIDs.map(qID => questionLookup[qID])

  var questionArr = filteredQuestions.map(q => q.title.replace(/<.*?>/gm, '').trim()) //trim removes trailing '\n'
  var aoa = [["Option", ...questionArr]]

  //build each option row array
  selectedOptions.forEach(opt => aoa.push(buildOptionRowArr(opt, filteredQuestionIDs, includeCavText, includeGreen))) 
    
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Caveat Matrix");
  XLSX.writeFile(wb, fisheryTitle + " - Caveat Matrix.xlsx");
}